import { render } from "./TermsConsentCheckbox.vue?vue&type=template&id=116fc231&scoped=true"
import script from "./TermsConsentCheckbox.vue?vue&type=script&lang=js"
export * from "./TermsConsentCheckbox.vue?vue&type=script&lang=js"

import "./TermsConsentCheckbox.vue?vue&type=style&index=0&id=116fc231&scoped=true&lang=css"

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116fc231"]])

export default __exports__